import * as React from 'react';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Message from '../Message';
import MessageInput from '../../Channels/Chat/MessageInput';
import useStyles from '../../../styles/multiPanel';

interface IMessageBoardProps {
    blockedStatusField: string;
    data: any[];
    fetchUserAvatar: Function;
    flagged: string;
    handleNewMessage: Function;
    heading: string;
    name: string;
    text: string;
    timestamp: string;
    toggleBlock: Function;
}

const MessageBoard: React.FunctionComponent<IMessageBoardProps> = ({
    blockedStatusField,
    data,
    fetchUserAvatar,
    flagged,
    handleNewMessage,
    name,
    text,
    timestamp,
    toggleBlock,
}) => {
    const classes = useStyles();
    const collectionRef = React.useRef<HTMLUListElement>(null);
    const scrollToBottom = () => {
        if (collectionRef && collectionRef.current) {
            collectionRef.current.scrollTop = collectionRef.current.scrollHeight;
        }
    };
    //Useful for chat windows
    React.useEffect(() => {
        scrollToBottom();
    }, [data]);
    return (
        <React.Fragment>
            <Paper className={classes.details} data-cy="MessageBoard">
                <Typography className={classes.heading} component="h5" variant="h5">
                    Comments
                </Typography>
                <List className={classes.momentsList} ref={collectionRef}>
                    {data &&
                        data.map(d => {
                            return (
                                <Message
                                    blockedStatusField={blockedStatusField}
                                    data={d}
                                    fetchUserAvatar={fetchUserAvatar}
                                    flagged={flagged}
                                    name={name}
                                    options={[]}
                                    text={text}
                                    timestamp={timestamp}
                                    toggleBlock={toggleBlock}
                                    userId="senderId"
                                />
                            );
                        })}
                </List>
            </Paper>
            <MessageInput handleCreateMessage={handleNewMessage} />
        </React.Fragment>
    );
};

export default MessageBoard;
